  <div [ngClass]="{'registration-container': !isModalOpened, 'registration-container-modal': isModalOpened}" *ngIf="{ termsAndConditionsContentJobseeker: 'text.TermsAndConditionsContentJobseeker' | translate : {site_name: (( website$ | async)?.displayName)},
                                             privacyPolicyContentJobseeker: 'text.PrivacyPolicyContentJobseeker' | translate : {site_name: (( website$ | async)?.displayName)},
                                             termsAndConditionsContentTitle: 'label.TermsAndConditions' | translate,
                                             privacyPolicyTitle: 'label.PrivacyPolicy' | translate
                                           } as data">

    <div class="registration" [ngClass]="{'registration-modal-unopened': !isModalOpened, 'registration-modal-opened': isModalOpened}">
      @if (!isModalOpened) {
        <p-tabs class="auth-tabs" [showNavigators]="false" [value]="registrationTab" (valueChange)="onTabChange($event)">
          <p-tablist>
            <p-tab [value]="signInTab">{{ 'label.SignIn' | translate }}</p-tab>
            <p-tab [value]="registrationTab">{{ 'label.Registration' | translate }}</p-tab>
          </p-tablist>
        </p-tabs>
      }

      <app-spinner [isLoading]="isLoading$ | async" [isFixedPosition]="false">
        <div class="registration-heading" *ngIf="!isModalOpened">
          <div class="registration-heading__main">
            {{ "label.Registration" | translate }}
          </div>
          <div class="registration-heading__comment">
            {{ "label.ForJobseeker" | translate }}
          </div>
        </div>
        <form [formGroup]="registrationForm" #ngForm="ngForm" (ngSubmit)="onRegister()" class="form">
    
          <div class="registration__email">
            <mat-form-field appearance="outline">
              <mat-label>{{ "label.Email" | translate }}</mat-label>
              <input matInput formControlName="email" />
              <mat-error *ngIf="registrationForm.controls['email'].errors?.required ">
                {{'message.MandatoryField' | translate}}
              </mat-error>
              <mat-error *ngIf="registrationForm.controls['email'].errors?.pattern">
                {{'message.IncorrectFormat' | translate}}
              </mat-error>
              <mat-error *ngIf="registrationForm.controls['email'].errors?.server != null">
                {{ getValidationMessage(registrationForm.controls['email'].errors?.server) | translate}}
              </mat-error>
            </mat-form-field>
          </div>
    
    
          <div class="registration__password">
             <hrra-password-input formControlName="password" [withPlaceholder]="true" placeholder="{{'label.Password' | translate}}">
             </hrra-password-input>
              <mat-error *ngIf="(registrationForm.controls['password'].errors?.pattern) && (registrationForm.controls['password'].touched || ngForm.submitted) && registrationForm.controls['password'].value?.length >= passwordMinLength" class="password-validation-error">
                {{'message.PasswordRequirementMessage' | translate}}
                <span [matTooltip]="'text.PasswordRequirementsText' | translate" >
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
              </mat-error>
              <mat-error class="password-validation-error" *ngIf="registrationForm.controls['password'].errors?.required && (registrationForm.controls['password'].touched || ngForm.submitted)">
                {{'message.MandatoryField' | translate}}
              </mat-error>
              <mat-error class="password-validation-error" *ngIf="registrationForm.controls['password'].errors?.minlength">
                {{'message.PasswordTooShort' | translate}}
              </mat-error>
          </div>
    
          <div class="registration__name">
            <mat-form-field appearance="outline">
              <mat-label>{{ "label.Name" | translate }}</mat-label>
              <input matInput formControlName="name" />
              <mat-error *ngIf="registrationForm.controls['name'].errors?.required ">
                {{'message.MandatoryField' | translate}}
              </mat-error>
              <mat-error *ngIf="registrationForm.controls['name'].errors?.pattern">
                {{'message.IncorrectFormat' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
    
    
          <div class="registration__surname">
            <mat-form-field appearance="outline">
              <mat-label>{{ "label.Surname" | translate }}</mat-label>
              <input matInput formControlName="surname" />
              <mat-error *ngIf="registrationForm.controls['surname'].errors?.required ">
                {{'message.MandatoryField' | translate}}
              </mat-error>
              <mat-error *ngIf="registrationForm.controls['surname'].errors?.pattern">
                {{'message.IncorrectFormat' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
    
          <div class="registration__phone">
            <mat-form-field appearance="outline">
              <mat-label>{{ "label.Phone" | translate }}</mat-label>
              <input matInput formControlName="phone" />
              <mat-error *ngIf="registrationForm.controls['phone'].errors?.required ">
                {{'message.MandatoryField' | translate}}
              </mat-error>
              <mat-error *ngIf="registrationForm.controls['phone'].errors?.pattern">
                {{'message.IncorrectFormat' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
    
    
          <div class="registration__recaptcha">
            <div style="transform:scale(0.9);transform-origin:0;">
              <re-captcha formControlName="recaptcha" siteKey="{{ recaptchaSiteKey$ | async }}"></re-captcha>
            </div>
            <mat-error
              *ngIf="(registrationForm.controls['recaptcha'].touched || ngForm.submitted) && registrationForm.controls['recaptcha'].errors?.required ">
              {{'message.MandatoryField' | translate}}
            </mat-error>
          </div>
    
          <div class="registration__terms">
            <mat-checkbox class="privacy-policy" formControlName="termsAndConditions">
                <span class="terms__text">{{'text.TermsAndConditionsAgreementPart1' | translate}}</span>&nbsp;
                <span (click)="onInfoPopup(data.termsAndConditionsContentJobseeker, data.termsAndConditionsContentTitle)" class="terms__link">{{'text.TermsAndConditionsAgreementLink1' | translate}}</span>&nbsp;
                <span class="terms__text">{{'text.TermsAndConditionsAgreementPart2' | translate}}</span>&nbsp;
                <span (click)="onInfoPopup(data.privacyPolicyContentJobseeker, data.privacyPolicyTitle)" class="terms__link">{{'text.TermsAndConditionsAgreementLink2' | translate}}</span>&nbsp;
                <span class="temrs__text">{{'text.TermsAndConditionsAgreementPart3' | translate}}</span>
            </mat-checkbox>
            <mat-error style="padding-left: 24px;"
              *ngIf="(registrationForm.controls['termsAndConditions'].touched || ngForm.submitted) && registrationForm.controls['termsAndConditions'].errors?.required ">
              {{'message.YouMustAgreeToProceed' | translate}}
            </mat-error>
          </div>
    
          <div class="registration__submit">
            <button class="registration__button">
              {{ "label.Registration" | translate }}
            </button>
          </div>
    
          <div *ngIf="registrationFailed$ | async" class="registration__failed-message">
            <app-jobseeker-error-message
              [messageHeading]="'message.CommonServerErrorSummary' | translate"
              [message]="'message.CommonServerErrorDetail' | translate">
            </app-jobseeker-error-message>
          </div>
        </form>
      </app-spinner>
    </div>
  <div class="recruitment" *ngIf="!isModalOpened">
    <app-jobseeker-recruitment-box></app-jobseeker-recruitment-box>
  </div>
</div>